module.exports = __webpack_public_path__ + "static/media/supplementQuestion.6ac8358d.png";